import { useState } from "react";
import axios from "axios";
import * as api from "../api/index";

export const useUploadForm = (url) => {
  const [isSuccess, setIsSuccess] = useState(false);
  const [progress, setProgress] = useState(0);

  const reset = () => {
    setIsSuccess(false);
    setProgress(0);
  };

  const uploadForm = async (fileData, file, metaData) => {
    const { safeName } = makeSafeFilename(fileData.filename);

    // Use safeName for blob
    const { data } = await api.createFileEntry(safeName, metaData);
    const { uploadURL, fileID } = data.data;

    // 🔹 Upload directly to Azure Blob Storage (no Authorization header needed!)
    await axios.put(uploadURL, file, {
      headers: {
        "x-ms-blob-type": "BlockBlob",
        "Content-Type": file.type || "application/octet-stream",
      },
      onUploadProgress: (progressEvent) => {
        const progress = (progressEvent.loaded / progressEvent.total) * 100;
        setProgress(progress);
      },
    });

    // 🔹 Notify backend that upload is complete
    const datacomplete = await api.uploadCompleted(fileID);

    setIsSuccess(true);
    setProgress(0);

    return datacomplete;
  };

  return { uploadForm, isSuccess, progress, reset };
};


function makeSafeFilename(originalName, maxLength = 50) {

  if (!originalName) return { safeName: "file", displayName: originalName };

  const lastDot = originalName.lastIndexOf(".");
  const hasExt = lastDot > 0 && lastDot < originalName.length - 1;
  const base = hasExt ? originalName.slice(0, lastDot) : originalName;
  const rawExt = hasExt ? originalName.slice(lastDot + 1) : "";

  // Extension ends up directly in the Azure blob path, so restrict it to alphanumerics.
  const safeExt = rawExt.replace(/[^a-zA-Z0-9]/g, "").toLowerCase(); 

  let safeBase = base
      .replace(/[^a-zA-Z0-9_-]+/g, "_")
      .replace(/_+/g, "_")
      .replace(/^_+|_+$/g, "")
      .trim();

  if (safeBase.length > maxLength) {
    safeBase = safeBase.substring(0, maxLength);
  }

  safeBase = safeBase || "file";

  const safeName = safeExt ? `${safeBase}.${safeExt}` : safeBase;  

  return { safeName, displayName: originalName };
}
